import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MeanValueTheorem = () => (
  <QPhototModuleSubtopic
    title="Mean value theorem"
    videos={[
      "https://www.youtube.com/embed/MenfT6Ib_P4",
      "https://www.youtube.com/embed/0MIx0hYUNP8",
      "https://www.youtube.com/embed/qUnkhLNKaIA"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_1.jpeg"
        },
        {
            image:"/cal_2.jpeg"
        },
        {
            image:"/cal_3.jpeg"
        },
        {
            image:"/cal_4.jpeg"
        }
        
    ]}
    exampleVideos={[]}
  />
);

export default MeanValueTheorem;
